export default __webpack_public_path__ + "static/media/login-background-epi.3c2a3c7a.png";